import { render, staticRenderFns } from "./SendTransitTicketForm.vue?vue&type=template&id=8500d556&scoped=true"
import script from "./SendTransitTicketForm.vue?vue&type=script&lang=ts"
export * from "./SendTransitTicketForm.vue?vue&type=script&lang=ts"
import style0 from "./SendTransitTicketForm.vue?vue&type=style&index=0&id=8500d556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8500d556",
  null
  
)

export default component.exports